<template>
  <div :class="$style.base">
    <Flex
      direction="column"
      :gap=".25"
    >
      <BaseHeading size="l">
        {{ $t('register.salonized_pay.dashboard.help.heading') }}
      </BaseHeading>
      <BaseText color="secondary">
        {{ $t('register.salonized_pay.dashboard.help.subheading', brandNamePay()) }}
      </BaseText>
    </Flex>

    <BaseCard :heading="$t('register.salonized_pay.landing.faq')">
      <FAQ :hasATerminal="hasTerminals" />
    </BaseCard>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { brandNamePay } from '@/helpers/brand-name';
import { useAdyenStore } from '@/stores/adyen';
import FAQ from '../../FAQ.vue';

const { hasTerminals } = storeToRefs(useAdyenStore());
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing * 1.5;
  width: 100%;
}
</style>
